import React, { useState, useEffect, useMemo } from 'react'
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import ReactDataTableBootstrap from '../../Components/ReactDataTableBootstrap/ReactDataTableBootstrap';
import Controllers from '../../Api/Controllers';
import { toast } from 'react-toastify';
import Helpers from '../../Components/Helpers/Helpers';
import SweetAlert from '../../Components/SweetAlert/SweetAlert'
import Modal from 'react-bootstrap/esm/Modal';
import ViaticosForm from './ViaticosForm';
import { HonestWeekPicker } from './HonestWeekPicker';
import { addMonths, endOfWeek, startOfWeek, subMonths } from "date-fns";

const ViaticosAll = ({ nameSingle, namePlural, separator }) => {
    const [isProcessing, setIsProccesing] = useState(true)
    const [reload, setReload] = useState(true);
    const [rows, setRows] = useState([])
    const [alertShow, setAlertShow] = useState(false)
    const [alertProps, setAlertProps] = useState({})
    const [alertLoad, setAlertLoad] = useState(false)
    const [modalShow, setModalShow] = useState(false);
    const [modalTitle, setModalTitle] = useState('');
    const [dataUpdated, setDataUpdated] = useState({})
    const [loadSubmit, setLoadSubmit] = useState(false)
    const [report, setReport] = useState({})

    const [filter, setFilter] = useState({
        date_start_viaticos_doc: Helpers.date.get({
            format: '%Y-%m-%d',
            startDate: startOfWeek(new Date(), { weekStartsOn: 1 })
        }),
        date_end_viaticos_doc: Helpers.date.get({
            format: '%Y-%m-%d',
            startDate: endOfWeek(new Date(), { weekStartsOn: 1 })
        }),
    })

    useEffect(() => {
        if (reload) {
            getReport()
        }
    }, [reload])

    const handleInsertUpdate = ({ data }) => {
        setLoadSubmit(true)
        Controllers.viaticos.viaticos_doc_insert_update(data).then(res => {
            Helpers.toast.construct({ ...res, toast })
            if (res.response === 'success') {
                setModalShow(false)
                setDataUpdated({})
            }
        }).catch(req => Helpers.promise.catch({ req, toast }))
            .finally(() => {
                setLoadSubmit(false)
                setReload(true)
            })
    }

    const onChange = (week) => {
        setFilter({
            date_start_viaticos_doc: Helpers.date.get({
                format: '%Y-%m-%d',
                startDate: week.firstDay
            }),
            date_end_viaticos_doc: Helpers.date.get({
                format: '%Y-%m-%d',
                startDate: week.lastDay
            })
        })
    };

    const getReport = _ => {
        setIsProccesing(true)
        Controllers.viaticos.get_viaticos_doc({
            p_date_start: filter.date_start_viaticos_doc,
            p_date_end: filter.date_end_viaticos_doc
        }).then(res => {
            setRows(res.data.rows)
            setReport({
                excel: res.data.excel.file,
                filename: res.data.excel.filename,
            })
        }).catch(req => Helpers.promise.catch({ req, toast }))
            .finally(() => {
                setIsProccesing(false)
                setReload(false)
            })
    }

    const handleGet = e => {
        let $this = e.currentTarget

        if (!$this.dataset?.idViaticosDoc) {
            setModalTitle(`Registrar ${nameSingle}`)
            setDataUpdated({})
            setModalShow(true);
            return
        }

        let { idViaticosDoc } = $this.dataset

        setModalTitle(`Modificar ${nameSingle} #${idViaticosDoc}`)
        setDataUpdated({
            data: {
                id_viaticos_doc: idViaticosDoc,
            },
            disabled: parseInt($this.dataset?.enabled) === 0
        })
        setModalShow(true);
    }

    const handleHideModalForm = () => {
        setModalShow(false)
        setLoadSubmit(false)
    }
    const dtRows = useMemo(() => <ReactDataTableBootstrap
        head={[
            [
                { name: 'id_viaticos_doc', text: 'ID', align: 'center' },
                { name: 'full_name', text: 'Trabajador', align: 'center' },
                { name: 'date_start_viaticos_doc', text: 'Fecha Inicio', align: 'center' },
                { name: 'date_end_viaticos_doc', text: 'Fecha Fin', align: 'center' },
                { name: 'total_viaticos_doc', text: 'Total', align: 'center' },
                {
                    name: 'total_comprobado', text: 'Comprobación', align: 'left', render: u => {
                        if (parseInt(u.status_viaticos_doc) !== 4) {
                            return <></>
                        }

                        return <>
                            <div className='mb-2'>
                                <span>{u.total_comprobado}</span>
                            </div>
                            <div>
                                <strong>Resto: </strong>
                                <span>{u.resto_comprobado}</span>
                            </div>
                        </>
                    }
                },
                {
                    name: 'total_resto', text: 'Reembolso', align: 'left', render: u => {
                        if (parseInt(u.status_viaticos_doc) !== 4) {
                            return <></>
                        }

                        return <>
                            <div>
                                <strong>Resto: </strong>
                                <span>{u.resto_comprobado}</span>
                            </div>
                            {u.image_reembolso && <div>
                                <a href={Helpers.config.resourcesUrl({
                                    url: u.image_reembolso
                                })}>
                                    <i className="fa fa-download"></i>
                                </a>
                            </div>}
                        </>
                    }
                },
                {
                    name: 'file_zip', text: 'Descargar', align: 'center', render: r => {
                        if (!r.file_zip) return <></>

                        return <a href={Helpers.config.resourcesUrl({
                            url: r.file_zip
                        })}>
                            <i className="fa fa-download"></i>
                        </a>
                    }
                },
                {
                    name: 'status_viaticos_doc', text: 'Estado', align: 'center', render: r => {
                        let statusText = ''
                        let color = ''
                        switch (r.status_viaticos_doc) {
                            case 0:
                                statusText = 'Pendiente'
                                color = 'info'
                                break;
                            case 1:
                                statusText = 'Enviado'
                                color = 'primary'
                                break;
                            case 2:
                                statusText = 'Aprobado'
                                color = 'success'
                                break;
                            case 3:
                                statusText = 'Rechazado'
                                color = 'danger'
                                break;
                            case 4:
                                statusText = 'Comprobado'
                                color = 'primary'
                                break;
                            default:
                                statusText = ''
                                color = ''
                                break;
                        }

                        return <div className={'badge badge-' + color}>
                            {statusText}
                        </div>
                    }
                },
                {
                    name: 'actions', text: <i className="fa fa-cog"></i>, align: 'center', render: u => {
                        return <div>
                            {<Button variant="info" className="mr-1" size="xs" data-id-viaticos-doc={u.id_viaticos_doc} onClick={handleGet} data-enabled="0">
                                <i className="fa fa-eye"></i>
                            </Button>}
                            {parseInt(u.status_viaticos_doc) === 2 && <Button variant="info" className="mr-1" size="xs" data-id-viaticos-doc={u.id_viaticos_doc} onClick={handleGet} data-enabled="1">
                                <i className="fa fa-edit"></i>
                            </Button>}
                            {parseInt(u.status_viaticos_doc) === 1 && <Button variant="success" className="mr-1" size="xs" data-id-viaticos-doc={u.id_viaticos_doc} onClick={e => {
                                setAlertProps({
                                    icon: 'approve',
                                    title: <>¿Desea aprobar {separator} {nameSingle}?</>,
                                    subtitle: <>#{u.id_viaticos_doc}</>,
                                    confirmButtonText: '¡Sí, aprobar!',
                                    cancelButtonText: '¡No!',
                                    loadSubmit: alertLoad,
                                    onConfirm: _ => {
                                        setAlertLoad(true)

                                        Controllers.viaticos.viaticos_doc_approve({
                                            p_id_viaticos_doc: u.id_viaticos_doc
                                        }).then(res => {
                                            Helpers.toast.construct({ ...res, toast })
                                            if (res.response === 'success') {
                                                setAlertShow(false)
                                            }
                                        }).catch(req => Helpers.promise.catch({ req, toast }))
                                            .finally(() => {
                                                setReload(true)
                                                setAlertLoad(false)
                                            })
                                    },
                                })
                                setAlertShow(true)
                            }}>
                                <i className="fas fa-check"></i>
                            </Button>}
                            {parseInt(u.status_viaticos_doc) === 1 && <Button variant="danger" className="mr-1" size="xs" data-id-viaticos-doc={u.id_viaticos_doc} onClick={e => {
                                setAlertProps({
                                    icon: 'delete',
                                    iconClassName: 'fas fa-ban text-danger',
                                    title: <>¿Desea rechazar {separator} {nameSingle}?</>,
                                    subtitle: <>#{u.id_viaticos_doc}</>,
                                    confirmButtonText: '¡Sí, rechazar!',
                                    cancelButtonText: '¡No!',
                                    loadSubmit: alertLoad,
                                    onConfirm: _ => {
                                        setAlertLoad(true)

                                        Controllers.viaticos.viaticos_doc_reject({
                                            p_id_viaticos_doc: u.id_viaticos_doc
                                        }).then(res => {
                                            Helpers.toast.construct({ ...res, toast })
                                            if (res.response === 'success') {
                                                setAlertShow(false)
                                            }
                                        }).catch(req => Helpers.promise.catch({ req, toast }))
                                            .finally(() => {
                                                setReload(true)
                                                setAlertLoad(false)
                                            })
                                    },
                                })
                                setAlertShow(true)
                            }}>
                                <i className="fas fa-ban"></i>
                            </Button>}
                        </div>
                    }
                },
            ],
        ]}
        rows={rows}
        isProcessing={isProcessing}
    />, [rows, isProcessing])

    return <>
        <Card>
            <Card.Header className="justify-content-between">
                <span>Listado De {namePlural}</span>
            </Card.Header>
            <Card.Body>
                <div className="mb-2">
                    <HonestWeekPicker onChange={onChange} />
                    <Button variant="primary" className="mt-2" onClick={getReport}>
                        <i className="fa fa-search mr-2"></i>Buscar
                    </Button>
                </div>
                {report?.filename ? <div className='mb-4'>
                    <a href={report?.excel} download={report?.filename} className="mr-2">
                        <Button size="sm" variant="success">
                            <i className="fa fa-file-excel mr-2"></i>Descargar Reporte Excel
                        </Button>
                    </a>
                </div> : ''}
                {dtRows}
            </Card.Body>
        </Card>
        <SweetAlert
            icon="delete"
            show={alertShow}
            {...alertProps}
            onCancel={_ => setAlertShow(false)}
        />
        <Modal show={modalShow} onHide={handleHideModalForm} backdrop="static" size='xl'>
            <Modal.Header closeButton>
                <Modal.Title as="div">{modalTitle}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <ViaticosForm onSubmit={handleInsertUpdate} loadSubmit={loadSubmit} {...dataUpdated} />
            </Modal.Body>
        </Modal>
    </>
}

export default ViaticosAll